import { ObjectKeyCell } from './ObjectKeyCell';
import { OnDefineKeysClick } from './interface';
import { ObjectsHeaderColumn } from '../../../interfaces/object-header';
import { ObjectKeys } from '../../../interfaces/object';

export interface ObjectsKeysCellProps {
  isViewMode?: boolean;
  cellHeader: ObjectsHeaderColumn;
  keys: ObjectKeys;
  onDefineKeysClick: OnDefineKeysClick;
}
export function ObjectsKeysCell({
  isViewMode,
  cellHeader,
  keys,
  onDefineKeysClick
}: ObjectsKeysCellProps) {
  const { requiredKeys, ...newKeys } = keys;

  return (
    <div className='d-flex flex-col justify-center'>
      {Object.entries(newKeys).map(([key, value]) => (
        <ObjectKeyCell
          key={key}
          isViewMode={isViewMode}
          objectKeyValue={value}
          keyConfig={cellHeader.additionalConfig?.[key]}
          isRequired={requiredKeys.includes(key)}
          onDefineKeysClick={onDefineKeysClick}
        />
      ))}
    </div>
  );
}
